import { useState } from 'react';
import { faqs } from '../data';
import { SectionHeader } from './SectionHeader';

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-background-50">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-5 lg:gap-10">
          <div className="lg:col-span-2">
            <SectionHeader
              kicker="先把疑问说清楚"
              title="关于今日看瓜，你想问的都在这"
              desc="我们把「这是什么、准不准、收不收费、怎么反馈」一次性讲明白，让你吃得放心、看得明白。"
            />
            <div className="rounded-2xl bg-secondary-100/70 p-5 md:p-6">
              <p className="mb-3 flex items-center gap-2 text-sm font-semibold text-secondary-900">
                <i className="ri-shield-check-line text-accent-600"></i>一句信任承诺
              </p>
              <p className="text-sm leading-relaxed text-foreground-700">
                只做公开信息的聚合与转载，官方与多方交叉信源优先，争议处明确标注——今日看瓜不抢做结论，只帮你更快看清正在发生的事。
              </p>
            </div>
          </div>

          <div className="lg:col-span-3">
            <div className="divide-y divide-background-100 overflow-hidden rounded-2xl border border-background-200 bg-background-100/40">
              {faqs.map((faq, idx) => {
                const open = openIdx === idx;
                return (
                  <button
                    key={faq.q}
                    type="button"
                    onClick={() => setOpenIdx(open ? null : idx)}
                    className="flex w-full flex-col items-start gap-2 px-5 py-4 text-left transition-colors hover:bg-background-100/80 md:px-6"
                  >
                    <span className="flex w-full items-center justify-between gap-3">
                      <span className="flex items-start gap-2.5 text-sm font-semibold text-foreground-900 md:text-base">
                        <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-primary-100 text-[11px] font-bold text-primary-600">
                          {String(idx + 1).padStart(2, '0')}
                        </span>
                        {faq.q}
                      </span>
                      <i
                        className={`ri-add-line mt-0.5 shrink-0 text-secondary-500 transition-transform duration-300 ${
                          open ? 'rotate-45' : ''
                        }`}
                      ></i>
                    </span>
                    {open && (
                      <p className="pl-8 text-sm leading-relaxed text-foreground-600">
                        {faq.a}
                      </p>
                    )}
                  </button>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}